<template lang="pug">
  .asset-pair
    span.base {{assetCode(baseAsset)}}
    span.reverse(@click="swapAssets") ⇋
    span.quote {{assetCode(quoteAsset)}}
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    computed: {
      ...mapState(['baseAsset', 'quoteAsset'])
    },
    methods: {
      ...mapActions(['swapAssets']),
      assetCode (asset) {
        return asset ? asset.code : 'XLM'
      }
    }
  }
</script>

<style lang="sass" scoped>
  .asset-pair
    display: flex
    align-items: center

    margin-left: 1rem

    font-weight: lighter
    font-size: 1.3rem

  .reverse
    margin: 0 0.5rem
    cursor: pointer
</style>
